import { RGBA } from '@ctrl/tinycolor'
import React, { useCallback } from 'react'
import { CloseButton } from 'src/editor/shared/ui-lib/buttons'
import { ColorTypeOptionEnum } from 'src/editor/shared/ui-lib/color-picker'
import { ColorPickerGradientAngle } from 'src/editor/shared/ui-lib/color-picker/color-picker-gradient-ui/color-picker-gradient-angle'
import { ColorPickerGradientPalette } from 'src/editor/shared/ui-lib/color-picker/color-picker-gradient-ui/color-picker-gradient-palette'
import {
  OptionType,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import { twJoin, twMerge } from 'tailwind-merge'

export interface ColorPickerSwitchProps {
  isGradientAvailable: boolean
  angle: number
  setAngle: (angle: number) => void
  gradient: [RGBA, RGBA]
  setGradient: ([gradientStart, gradientEnd]: [RGBA, RGBA]) => void
  activeGradientIndex: number
  setActiveGradientIndex: (index: number) => void
  colorType: OptionType<ColorTypeOptionEnum>
  setColorType: (type: OptionType<ColorTypeOptionEnum>) => void
  onClose: () => void
  colorTypeOptions: OptionType<ColorTypeOptionEnum>[]
}

export const ColorPickerSwitch = ({
  isGradientAvailable,
  angle,
  setAngle,
  activeGradientIndex,
  setActiveGradientIndex,
  gradient,
  colorType,
  setColorType,
  onClose,
  colorTypeOptions,
}: ColorPickerSwitchProps) => {
  const handleSelectOption = useCallback(
    (option: OptionType<ColorTypeOptionEnum> | null) => {
      if (option) {
        setColorType(option)
      }
    },
    [setColorType],
  )

  return (
    <div>
      <div
        className={twMerge(
          'flex justify-end',
          isGradientAvailable && 'items-start justify-between',
        )}
      >
        {isGradientAvailable && (
          <SelectNew
            size="small"
            className="h-8"
            wrapperClassName={twJoin(
              'min-w-[80px] pt-0',
              colorType.value === ColorTypeOptionEnum.GRADIENT &&
                'last-of-type:mb-8',
            )}
            selectedOption={colorType}
            isMulti={false}
            onChange={handleSelectOption}
            options={colorTypeOptions}
          />
        )}
        <CloseButton onClick={onClose} />
      </div>
      {colorType.value === ColorTypeOptionEnum.GRADIENT && (
        <div className="flex flex-col items-center justify-between">
          <ColorPickerGradientPalette
            activeGradientIndex={activeGradientIndex}
            setActiveGradientIndex={setActiveGradientIndex}
            gradient={gradient}
          />
          <ColorPickerGradientAngle angle={angle} setAngle={setAngle} />
        </div>
      )}
    </div>
  )
}
